import React from "react";
import { useHint } from "react-bootstrap-typeahead";

type HintProps = {
	children: React.ReactNode;
	className?: string;
};

// Wrapper component to make a gray hint text inside of the address search input
const HintCustom = ({ children, className = "" }: HintProps) => {
	const { hintRef, hintText } = useHint();

	return (
		<div
			className={className}
			style={{
				display: "flex",
				flex: 1,
				height: "100%",
				position: "relative",
			}}
		>
			{children}
			<input
				aria-hidden
				className="rbt-input-hint"
				ref={hintRef}
				readOnly
				style={{
					backgroundColor: "transparent",
					borderColor: "transparent",
					boxShadow: "none",
					left: 0,
					pointerEvents: "none",
					position: "absolute",
					top: 0,
					width: "100%",
					zIndex: -1,
				}}
				tabIndex={-1}
				value={hintText}
			/>
		</div>
	);
};

export default HintCustom;
